/**
 * Ayuda — Administración → Cobros → Recibos
 */

/** @type {import('../help-index.js').HelpSidebarItem} */
export const ADM_COL_VOUCHERS_ITEM = {
  id: 'vouchersAdmin',
  screenId: 'adm-col-vouchers',
  label: 'Recibos',
  description: 'Registrá y consultá recibos de cobro a clientes.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Un recibo documenta que un cliente te pagó. Indicás con qué medios cobraste (efectivo, transferencia, cheque, etc.) y a qué facturas o conceptos se aplica ese dinero.',
      },
      {
        title: 'Paso 1 — Buscar recibos',
        fields: [
          { label: 'Fecha Desde / Fecha Hasta', description: 'Filtrá por el período del recibo.' },
          { label: 'Cliente', description: 'Elegí un cliente para ver solo sus recibos.' },
          { label: 'Buscar', description: 'Actualiza la lista.' },
        ],
      },
      {
        title: 'Paso 2 — Leer la lista',
        bullets: [
          'Fecha, Cliente, Tipo de recibo, Número y Observaciones.',
          'Tocá una fila para ver el detalle del recibo.',
          'Ícono de cruz (×) — eliminar el recibo (pide confirmación).',
        ],
        paragraphs: [
          'El ícono de lápiz no permite editar; al tocarlo también abre el detalle.',
        ],
      },
      {
        title: 'Paso 3 — Cargar un recibo nuevo',
        intro: 'El botón + abre «Nuevo Recibo».',
      },
      {
        title: 'Datos del recibo',
        fields: [
          { label: 'Cliente', description: 'Buscá y elegí quién te pagó. Obligatorio.' },
          { label: 'Fecha', description: 'Fecha del cobro. Obligatoria.' },
          { label: 'Tipo de recibo', description: 'Tipo de comprobante configurado (por ejemplo Recibo X).' },
          { label: 'Centro / Número', description: 'Punto de venta y numeración del recibo.' },
        ],
      },
      {
        title: 'Conceptos a imputar',
        intro:
          'Indicás a qué se aplica el cobro. En cada línea elegís el concepto y el monto:',
        bullets: [
          'Factura de cliente — imputás el pago a una o más facturas pendientes del cliente.',
          'Anticipo de cobro — el cliente paga por adelantado sin factura específica.',
          'Otros conceptos — según lo configurado en el sistema.',
        ],
        paragraphs: [
          'Podés agregar varias líneas con «AGREGAR LINEA».',
          'Primero elegí el cliente para que el sistema pueda mostrar facturas pendientes.',
        ],
      },
      {
        title: 'Forma de pago',
        intro: 'Indicás cómo te pagó el cliente. En cada línea elegís el medio y el importe:',
        bullets: [
          'Efectivo — dinero en caja.',
          'Banco — transferencia o depósito.',
          'Cheques recibidos — cheque de un cliente.',
          'Cupones de tarjeta — cobro con tarjeta de crédito o débito.',
          'Cobro QR — pago con código QR.',
          'Anticipo — usar un anticipo previo del cliente.',
          'Otros medios — según configuración.',
        ],
        paragraphs: [
          'Podés combinar varios medios en un mismo recibo (por ejemplo parte efectivo y parte transferencia).',
          '«AGREGAR LINEA» suma otro medio de pago.',
        ],
      },
      {
        title: 'Observaciones y guardar',
        fields: [
          { label: 'Observaciones', description: 'Notas generales (opcional).' },
          { label: 'Limpiar formulario', description: 'Borra todo para cargar otro recibo.' },
          { label: 'Guardar', description: 'Registra el recibo e imputa los pagos a las facturas o conceptos elegidos.' },
        ],
      },
      {
        title: 'Ver el detalle de un recibo',
        bullets: [
          'Tipo, número, fecha y datos del cliente.',
          'Imputaciones — a qué facturas o conceptos se aplicó el cobro.',
          'Forma de pagos — medios usados e importes. Tocá una fila para ver el detalle del movimiento (caja, banco, etc.).',
          'Observaciones y quién lo creó.',
        ],
      },
      {
        title: 'Eliminar un recibo',
        intro:
          'Tocá la cruz en la lista. Confirmá con «Si» o cancelá. Si el recibo tiene imputaciones complejas, el sistema puede pedir confirmación extra antes de borrar.',
      },
    ],
  },
}
